import reflection2022 from './all_blogs/reflection2022.json';
import canSpam from './all_blogs/canSpam.json';
import reflection2024 from './all_blogs/reflection2024.json';
import reflection2023 from './all_blogs/reflection2023.json';
import timeBasedMaintanence from './all_blogs/timeBasedMaintanence.json';
import problemsWithPlastic from './all_blogs/problemsWithPlastic.json';

export const AllBlogs = [
    {path: 'reflection2022', data: reflection2022},
    {path: 'canSpam', data: canSpam},
    {path: 'reflection2024', data: reflection2024},
    {path: 'reflection2023', data: reflection2023},
    {path: 'timeBasedMaintanence', data: timeBasedMaintanence},
    {path: 'problemsWithPlastic', data: problemsWithPlastic},
];
export const ArticlesExcludedFromComments = [
    reflection2022.title,
    reflection2024.title,
    reflection2023.title,
];